"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'task.creation.title',
        defaultMessage: 'Create a new task',
        description: 'Create task title',
    },
    step1Title: {
        id: 'task.creation.steps.1.title',
        defaultMessage: 'Worktype',
        description: 'Task creation step 1 title',
    },
    step1Description: {
        id: 'task.creation.steps.1.description',
        defaultMessage: 'Please select a worktype',
        description: 'Task creation step 1 description',
    },
    step2Description: {
        id: 'task.creation.steps.2.description',
        defaultMessage: 'More details about your task',
        description: 'Task creation step 2 description',
    },
    step2Sub1Title: {
        id: 'task.creation.steps.2.sub.1.title',
        defaultMessage: 'Select a machine',
        description: 'Task creation step 2 sub step 1 title',
    },
    step2Sub1Description: {
        id: 'task.creation.steps.2.sub.1.description',
        defaultMessage: 'A few details about your machine',
        description: 'Task creation step 2 sub step 1 description',
    },
    step2Sub2Title: {
        id: 'task.creation.steps.2.sub.2.title',
        defaultMessage: 'Select an implement',
        description: 'Task creation step 2 sub step 2 title',
    },
    step2Sub2Description: {
        id: 'task.creation.steps.2.sub.2.description',
        defaultMessage: 'A few details about your implement',
        description: 'Task creation step 2 sub step 2 description',
    },
    step2Sub3Title: {
        id: 'task.creation.steps.2.sub.3.title',
        defaultMessage: 'Select a team',
        description: 'Task creation step 2 sub step 3 title',
    },
    step2Sub3Description: {
        id: 'task.creation.steps.2.sub.3.description',
        defaultMessage: 'Choose your team member',
        description: 'Task creation step 2 sub step 3 description',
    },
    step2Sub4Title: {
        id: 'task.creation.steps.2.sub.4.title',
        defaultMessage: 'Select a field',
        description: 'Task creation step 2 sub step 4 title',
    },
    step2Sub4Description: {
        id: 'task.creation.steps.2.sub.4.description',
        defaultMessage: 'A few details about your field',
        description: 'Task creation step 2 sub step 4 description',
    },
    step2Sub5Title: {
        id: 'task.creation.steps.2.sub.5.title',
        defaultMessage: 'Select the crop ',
        description: 'Task creation step 2 sub step 5 title',
    },
    step2Sub5Description: {
        id: 'task.creation.steps.2.sub.5.description',
        defaultMessage: 'Lorem ipsum',
        description: 'Task creation step 2 sub step 5 description',
    },
    step2Sub6Title: {
        id: 'task.creation.steps.2.sub.6.title',
        defaultMessage: 'Select seed',
        description: 'Task creation step 2 sub step 6 title',
    },
    step2Sub6Description: {
        id: 'task.creation.steps.2.sub.6.description',
        defaultMessage: 'Lorem ipsum',
        description: 'Task creation step 2 sub step 6 description',
    },
    step3Description: {
        id: 'task.creation.steps.3.description',
        defaultMessage: 'Select send task to tractor or save task',
        description: 'Task creation step 3 description',
    },
    step3Title: {
        id: 'task.creation.steps.3.title',
        defaultMessage: 'Send, download or save',
        description: 'Task creation step 3 title',
    },
    step3Sub1Title: {
        id: 'task.creation.steps.3.sub.1.title',
        defaultMessage: 'Check task details',
        description: 'Task creation step 3 sub step 1 title',
    },
    step3Sub1Description: {
        id: 'task.creation.steps.3.sub.1.description',
        defaultMessage: 'Rename your task. Take a note',
        description: 'Task creation step 3 sub step 1 description',
    },
    send: {
        id: 'task.creation.send',
        defaultMessage: 'Send',
        description: 'Send button',
    },
    saveAsDraft: {
        id: 'task.creation.saveAsDraft',
        defaultMessage: 'Save as draft',
        description: 'Task creation save as draft',
    },
    searchOrSelect: {
        id: 'task.creation.machine.searchOrSelect',
        defaultMessage: 'Search or select',
        description: 'Task creation search or select',
    },
    searchAllMachines: {
        id: 'task.creation.machine.searchAllMachines',
        defaultMessage: 'Search all machines',
        description: 'Task creation search all machines',
    },
    searchMachine: {
        id: 'task.creation.machine.searchMachine',
        defaultMessage: 'Search machine',
        description: 'Task creation search machine',
    },
    suggestedMachines: {
        id: 'task.creation.machine.suggestedMachines',
        defaultMessage: 'Suggested machines',
        description: 'Task creation suggested machines',
    },
    noMachineSelected: {
        id: 'task.creation.machine.noMachineSelected',
        defaultMessage: 'No machine selected',
        description: 'Task creation no machine selected',
    },
    allMachines: {
        id: 'task.creation.machine.allMachines',
        defaultMessage: 'All machines',
        description: 'Task creation all machines',
    },
    taskName: {
        id: 'task.creation.summary.taskName',
        defaultMessage: 'Task name',
        description: 'Task creation, check task details, task name',
    },
    taskNameHint: {
        id: 'task.creation.summary.taskName.hint',
        defaultMessage: 'Max {characters, plural, one {# character} other {# characters}}',
        description: 'Task creation, check task details, task name, hint: Max 32 characters',
    },
    taskNameTooltip: {
        id: 'task.creation.summary.taskName.tooltip',
        defaultMessage: 'Name of the task is automatically created with date and worktype. You can rename it.',
        description: 'Task creation, check task details, task name tooltip text',
    },
    taskNameValidationRequired: {
        id: 'task.creation.summary.taskName.validation.required',
        defaultMessage: 'Please enter task name',
        description: 'Task creation, check task details, task name required validation',
    },
    taskNameCharactersLeft: {
        id: 'task.creation.summary.taskName.character.left',
        defaultMessage: '{characters, plural, one {# character} other {# characters}} left',
        description: 'Task creation, shows how many characters left in task name',
    },
    taskCreationComplete: {
        id: 'task.creation.lastStep.complete',
        defaultMessage: 'Complete',
        description: 'Label of the button of the last step in task creation',
    },
    taskCreationSuccessTitle: {
        id: 'task.creation.ready.title',
        defaultMessage: 'Task details successfully added',
        description: 'Title of success task creation panel',
    },
    taskCreationSuccessSubTitle: {
        id: 'task.creation.ready.subTitle',
        defaultMessage: 'Your task will be saved as draft. You can edit later.',
        description: 'Subtitle of success task creation panel',
    },
    taskCreationSuccessPrepareTitle: {
        id: 'task.creation.ready.prepare.title',
        defaultMessage: 'Prepare task file for Download',
        description: 'Title of prepare option on success task creation panel',
    },
    taskCreationSuccessPrepareSubTitle: {
        id: 'task.creation.ready.prepare.subTitle',
        defaultMessage: 'Task file will be prepared and you will be informed when ready for download.',
        description: 'Subtitle of prepare option on success task creation panel',
    },
    taskCreationSuccessSaveAsSubtitle: {
        id: 'task.creation.ready.saveAs.subTitle',
        defaultMessage: 'Lorem ipsum dolor....',
        description: 'Subtitle of save as option on success task creation panel',
    },
    taskCreationCancelModalTitle: {
        id: 'task.creation.ready.cancelModal.title',
        defaultMessage: 'Quit task creation?',
        description: 'Title of task creation cancel modal',
    },
    taskCreationCancelModalSubTitle: {
        id: 'task.creation.ready.cancelModal.subTitle',
        defaultMessage: 'Cancelling a task will not save the task as draft. Do you wish to cancel?',
        description: 'Subtitle of task creation cancel modal',
    },
    saveAsDraftNotCompletedDescription: {
        id: 'task.creation.saveAsDraft.notCompleted.description',
        defaultMessage: 'Task creation is not yet completed. Do you wish to continue to save?',
        description: 'Task not completed save as draft description',
    },
});
exports.default = messages;
